module.exports = __webpack_public_path__ + "static/laptop-graphic-d09ea37fc502c7262907cfedfc653a08.png";